import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faLock, faEye, faEdit, faSave } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../../../context/auth';
import perfil_api from '../../../../../api/perfil_api';
import { showMessage } from '../../../../../helpers/message';

export default function EtapasFiscalizacao({ perfil, editavel, handleVoltar, listFiscalizacaoEtapas }) {
    const { setLoading } = useAuth();
    const [showContent, setShowContent] = useState({});
    const [etapasConfig, setEtapasConfig] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState({}); 

    useEffect(() => { 
        const initialShowContent = {};
        const initialEtapasConfig = {};
        const initialDropdownOpen = {};
        
        listFiscalizacaoEtapas?.forEach(roteiro => {
            initialShowContent[roteiro.identificacao] = true;
            initialDropdownOpen[roteiro.identificacao] = false;
            
            const etapasConfiguradas = roteiro.etapas.map(etapa => {
                const permissaoExistente = perfil.perfilFiscalizacaoEtapas?.find(  p => p.hash === etapa.hash  );
                
                return {
                    ...etapa,
                    permissao: permissaoExistente?.acao || 'Bloqueado'
                };
            });
            
            initialEtapasConfig[roteiro.identificacao] = {
                option: 'Selecione',  
                etapas: etapasConfiguradas
            };
        });
        
        setShowContent(initialShowContent); 
        setEtapasConfig(initialEtapasConfig);
        setDropdownOpen(initialDropdownOpen);
    }, [perfil, listFiscalizacaoEtapas]);

    const toggleContent = (identificacao) => {
        setShowContent({
        ...showContent,
        [identificacao]: !showContent[identificacao]
        });
    };

    const toggleDropdown = (identificacao) => {
        setDropdownOpen({
        ...dropdownOpen,
        [identificacao]: !dropdownOpen[identificacao]
        });
    };

   const handleRoteiroOptionChange = (identificacao, option) => {
      setEtapasConfig(prev => ({
          ...prev,
          [identificacao]: {
              option,
              etapas: prev[identificacao].etapas.map(etapa => ({
              ...etapa,
              permissao: option
              }))
          }
      }));
    };

    const handleEtapaOptionChange = (roteiroId, etapaIndex, option) => {
      setEtapasConfig(prev => ({
          ...prev,
          [roteiroId]: {
              ...prev[roteiroId],
              etapas: prev[roteiroId].etapas.map((etapa, index) => 
              index === etapaIndex ? { ...etapa, permissao: option } : etapa
              )
          }
      }));
    };

  const renderPermissaoIcon = (permissao) => {
    let icon;
    let label;

    switch (permissao) {
      case 'Bloqueado':
        icon = <FontAwesomeIcon icon={faLock} className="text-danger me-2" />;
        label = 'Bloqueado';
        break;
      case 'Visualizar':
        icon = <FontAwesomeIcon icon={faEye} className="text-primary me-2" />;
        label = 'Visualizar';
        break; 
      default:
        icon = <FontAwesomeIcon icon={faEye} className="text-primary me-2" />;
        label = 'Visualizar';
        break;
    }

    return (
      <>
        {icon}
        {label}
      </>
    );
  };

  async function handleSalvarEtapasFiscalizacao() {
    const etapasParaSalvar = Object.values(etapasConfig).flatMap(config =>
        config.etapas.map(etapa => ({
            hash: etapa.hash,
            acao: etapa.permissao
        }))
    )
    try {
        setLoading(true);
        await perfil_api.PostPerfilFiscalizacaoEtapa(perfil.id, etapasParaSalvar);
        showMessage("Sucesso", "Operação realizada com sucesso", "success", handleVoltar);
    } catch (err) {
        showMessage("Error", err?.message ?? "Erro na operação.", "error", null);
    } finally {
        setLoading(false);
    }
  }


  return (
    <div className="container-fluid "> 
      <div className={`d-flex align-items-center justify-content-start my-3 ${editavel ? "" : "d-none"}`}>
        <Button
          color='success'
          className='px-4'
          onClick={handleSalvarEtapasFiscalizacao}
        >
          <FontAwesomeIcon icon={faSave} /> Salvar etapas de fiscalização
        </Button> 
      </div>
      <div className="d-flex flex-wrap gap-3">
        {listFiscalizacaoEtapas?.map((roteiro, index) => (
          <div key={index} className="flex-fill" style={{ minWidth: '48%', maxWidth: '100%' }}>
            <div className="card mb-3 h-100">
              <div 
                className="card-header d-flex justify-content-between align-items-center"
                style={{ cursor: 'pointer' }}
                onClick={() => toggleContent(roteiro.identificacao)}
              >
                <h5 className="mb-0">{roteiro.identificacao}</h5>
                <FontAwesomeIcon 
                  icon={showContent[roteiro.identificacao] ? faChevronUp : faChevronDown} 
                />
              </div>
            
              {showContent[roteiro.identificacao] && (
                <div className="card-body">
                  <div className="mb-3">
                    <Dropdown
                      isOpen={dropdownOpen[roteiro.identificacao]}
                      toggle={() => toggleDropdown(roteiro.identificacao)}
                    >
                      <DropdownToggle caret color='primary'>
                        Ação para todos: {etapasConfig[roteiro.identificacao]?.option || 'Selecione'}
                      </DropdownToggle>
                      <DropdownMenu color=''>
                        <DropdownItem 
                          onClick={() => handleRoteiroOptionChange(roteiro.identificacao, 'Bloqueado')}
                        >
                          Bloquear Todos
                        </DropdownItem>
                        <DropdownItem 
                          onClick={() => handleRoteiroOptionChange(roteiro.identificacao, 'Visualizar')}
                        >
                          Visualizar Todos
                        </DropdownItem> 
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                
                  <ul className="list-group">
                    {roteiro.etapas
                      .sort((a, b) => a.sequenciaDashboard - b.sequenciaDashboard)
                      .map((etapa, etapaIndex) => (
                        <li key={etapaIndex} className="list-group-item d-flex justify-content-between align-items-center">
                          <div>
                            <span className="fw-bold"></span> {etapa.descricao}
                          </div>
                          
                          <div className="d-flex align-items-center">
                            <Dropdown
                              isOpen={dropdownOpen[`${roteiro.identificacao}-${etapaIndex}`]} 
                              toggle={() => setDropdownOpen(prev => ({
                                ...prev,
                                [`${roteiro.identificacao}-${etapaIndex}`]: !prev[`${roteiro.identificacao}-${etapaIndex}`]
                              }))}
                            >
                              <DropdownToggle caret className="bg-white text-dark">
                                {renderPermissaoIcon(etapasConfig[roteiro.identificacao]?.etapas[etapaIndex]?.permissao)}
                              </DropdownToggle>
                              <DropdownMenu className="bg-white">
                                <DropdownItem 
                                  className='bg-white text-dark'
                                  onClick={() => handleEtapaOptionChange(roteiro.identificacao, etapaIndex, 'Bloqueado')}
                                >
                                  Bloqueado
                                </DropdownItem>
                                <DropdownItem 
                                  onClick={() => handleEtapaOptionChange(roteiro.identificacao, etapaIndex, 'Visualizar')}
                                >
                                  Visualizar
                                </DropdownItem> 
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))}
      </div> 
    </div>
  );
}